import React from 'react'

const CLockStopWatch = ({
    size = 72,
    bgColor = "#FFF5E8",
    stroke = "#FF9800"
}) => {
    return (
        <div
            style={{
                width: size,
                height: size,
                borderRadius: "9999px",
                background: bgColor,

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                flexShrink: 0
            }}
        >
            <svg
                width={95}
                height={95}
                viewBox="0 0 24 24"
                fill="none"
            >
                <circle
                    cx="12"
                    cy="13"
                    r="6.5"
                    stroke={stroke}
                    strokeWidth="2"
                />

                <path
                    d="M10 5H14"
                    stroke={stroke}
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <path
                    d="M12 5V6"
                    stroke={stroke}
                    strokeWidth="2"
                />

                <path
                    d="M7 7.5L8 8.5"
                    stroke={stroke}
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <path
                    d="M17 7.5L16 8.5"
                    stroke={stroke}
                    strokeWidth="2"
                    strokeLinecap="round"
                />

                <path
                    d="M12 11V15"
                    stroke={stroke}
                    strokeWidth="2"
                    strokeLinecap="round"
                />
            </svg>
        </div>

    )
}

export default CLockStopWatch